import { render, staticRenderFns } from "./TableDetailDialog.vue?vue&type=template&id=5c56ca53&scoped=true"
import script from "./TableDetailDialog.vue?vue&type=script&lang=js"
export * from "./TableDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./TableDetailDialog.vue?vue&type=style&index=0&id=5c56ca53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c56ca53",
  null
  
)

export default component.exports